let _ = (t)=>t, t;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { css } from '@emotion/react';
import { Button, Divider, Group, KlarnaLogo, Modal, Text, tokens } from '@klarna/ui';
import RichTextMarkdown from 'features/richText/components/richTextMarkdown/RichTextMarkdown';
import { getCountryCode } from 'framework/utils/core/siteUtils';
import { memo } from 'react';
import Disclaimer from './components/Disclaimer';
import InstallmentBreakdown from './components/InstallmentBreakdown';
import { useInstallmentsModalTranslations } from './useInstallmentsModalTranslations';
export const getPaymentOption = (termLength)=>{
    return termLength <= 4 ? 'PAY_IN_X' : 'FINANCING';
};
/**
 * Generic installments modal (no merchant context).
 * Shows payment breakdown and Klarna information.
 */ const InstallmentsModal = ({ open, onCtaClick, onClose, installment, offerPrice })=>{
    const { modalTitle, mainDescription, disclaimer, goToProductPage, getWhatYouLove, learnMore } = useInstallmentsModalTranslations(installment.termLength);
    const isUkMarket = getCountryCode() === 'UK';
    return /*#__PURE__*/ _jsxs(Modal, {
        maxHeight: "90%",
        maxWidth: {
            default: '100%',
            '@breakpoint[desktop]': 500
        },
        mobileAppearance: "bottom-sheet",
        open: open,
        onClose: onClose,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                heading: modalTitle,
                headingBehaviour: "header-always",
                leftArea: isUkMarket ? /*#__PURE__*/ _jsx(KlarnaLogo, {
                    logoType: "text",
                    size: 24
                }) : undefined
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: /*#__PURE__*/ _jsxs(Group, {
                    direction: "vertical",
                    gap: "space/24",
                    children: [
                        /*#__PURE__*/ _jsxs(Group, {
                            direction: "vertical",
                            gap: "space/8",
                            children: [
                                /*#__PURE__*/ _jsx(Text, {
                                    fontWeight: "bold",
                                    textToken: "label/l",
                                    children: mainDescription
                                }),
                                /*#__PURE__*/ _jsx(Text, {
                                    color: "text/body",
                                    textToken: "body/m",
                                    children: getWhatYouLove
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(InstallmentBreakdown, {
                            installment: installment,
                            offerPrice: offerPrice
                        }),
                        /*#__PURE__*/ _jsx(Divider, {}),
                        /*#__PURE__*/ _jsx(LearnMoreText, {
                            children: learnMore
                        }),
                        /*#__PURE__*/ _jsx(Disclaimer, {
                            children: disclaimer
                        })
                    ]
                })
            }),
            onCtaClick && /*#__PURE__*/ _jsx(Modal.Footer, {
                children: /*#__PURE__*/ _jsx(Button, {
                    size: "m",
                    onClick: onCtaClick,
                    children: goToProductPage
                })
            })
        ]
    });
};
/**
 * Styled markdown text for the "Learn More" section.
 */ const LearnMoreText = ({ children })=>/*#__PURE__*/ _jsx(RichTextMarkdown, {
        sx: css(t || (t = _`
      max-width: 100%;

      p,
      p > *,
      a {
        font-size: ${0}px;
        line-height: ${0}px;
        color: ${0};
      }

      a:hover,
      a:focus {
        color: ${0};
      }
    `), tokens.textSizes['text/desktop/s'], tokens.lineHeights['body/desktop/s'], tokens.colors.light['text/subtle'], tokens.colors.light['text/subtle']),
        children: children
    });
export default /*#__PURE__*/ memo(InstallmentsModal);
